import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import LandingPage from './routes/LandingPage'
import SubscriptionPage from './routes/SubscriptionPage'
import HomePage from './routes/HomePage'
import GamePage from './routes/GamePage'
import LoginPage from './routes/LoginPage'
import OtpPage from './routes/OtpPage'
import LeaderboardPage from './routes/LeaderboardPage'
import ProfilePage from './routes/ProfilePage'
import WinnersPage from './routes/WinnersPage'
import CategoryPage from './routes/CategoryPage'
import LanguageSelector from './component/LanguageSelector'
import ConfirmationPage from './routes/ConfirmationPage'
import AuthGuard from './routes/AuthGuard'

const App = () => {
  const router = createBrowserRouter([
    // {
    //   path: "/",
    //   element: <>
    //     <LandingPage />
    //     <LanguageSelector />
    //   </>
    // },
    {
      path: "/",
      element: 
      <>
      <SubscriptionPage />
          <LanguageSelector />
      </>
    },
    {
      path: "/login",
      element:( 

        <AuthGuard>
      <>
      <LoginPage />
          <LanguageSelector />
      </>
      </AuthGuard>
      )
    },
    {
      path: "/otp",
      element: (
        
      <>
      <OtpPage />
          <LanguageSelector />
      </>
     
      )
    },
    {
      path: "/home",
      element: (
       <AuthGuard>
      <>
      <HomePage />
          <LanguageSelector />
      </>
     </AuthGuard>
  )},


  {
      path: "/home/:msisdn",
      element: (
       <AuthGuard>
      <>
      <HomePage />
          <LanguageSelector />
      </>
     </AuthGuard>
  )},

    {
      path: "/category",
      element: (
 <AuthGuard>
      <>
      <CategoryPage />
          <LanguageSelector />
      </>
      </AuthGuard>
  )
    },
    {
      path: "/game",
      element:(
        <AuthGuard>
       <GamePage />
       </AuthGuard>
      )
    },
    {
      path: "/winners",
      element: (
        <AuthGuard>
      <>
      <WinnersPage />
          <LanguageSelector />
      </>
      </AuthGuard>
  )},
    {
      path: "/leaderboard",
      element: (
        <AuthGuard>
      <>
      <LeaderboardPage />
          <LanguageSelector />
      </>
      </AuthGuard>
      )
    },
    {
      path: "/profile",
      element: (
        <AuthGuard>
      <>
      <ProfilePage />
          <LanguageSelector />
      </>
      </AuthGuard>
      )
    },   {
      path: "/confirmation",
      element: 
      <>
      <ConfirmationPage />
          <LanguageSelector />
      </>
    }
  ])
  return (
    <RouterProvider router={router} />
  )
}

export default App